module App.Interfaces {
    export interface IFacetResponse {
        properties: IFacets[];
    }

    export interface IFacets {
        name: string;
        type: number;
        values: IFacet[];
    }

    export interface IFacet {
        value: string;
        display: string;
        count: number;
    }
}